import { App as AppCap } from "@capacitor/app";
import {
  ActionPerformed,
  PushNotificationSchema,
  PushNotifications,
  Token,
} from "@capacitor/push-notifications";
import {
  IonAlert,
  IonApp,
  IonLoading,
  IonToast,
  setupIonicReact,
  useIonRouter,
} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import "@ionic/react/css/core.css";
import "@ionic/react/css/display.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/padding.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/typography.css";
import { useContext, useEffect, useRef, useState } from "react";
import { Redirect, withRouter } from "react-router-dom";
import "./App.css";
import App1 from "./AppEventListenerInitializer";
import UserPrefencesContext, {
  UserPreferences,
} from "./components/contexts/UserPreferencesContext";
/* Theme */
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";
import { Capacitor } from "@capacitor/core";
import "driver.js/dist/driver.css";
import {
  alertCircleOutline,
  checkmarkCircleOutline,
  informationCircle,
  wifi,
} from "ionicons/icons";
import { isArray } from "underscore";
import { v4 as uuidv4 } from "uuid";
import { CMEDRoutes } from "./platforms/PlatformsSwitcher/Constants";
import { AccessTokenContextType } from "./components/contexts/AccessTokenContext";
import BeaconAccessContext from "./components/contexts/BeaconAccessContext";
import { EntitlementContextType } from "./components/contexts/EntitlementContext";
import config from "./components/helpers/socket/config";
import { pubsubEvents } from "./components/helpers/socket/pubsubEvent";
import optionGridConfig from "./platforms/cmed/OptionsGrid/optionsGridConfig";
import PlatformsSwitcher from "./platforms/PlatformsSwitcher/PlatformsSwitcher";
import { DesktopBrowser, MobileBrowser } from "./routing/AuthRedirect";
import DesktopHeader from "./routing/DesktopHeader";
import "./theme/dark.css";
import "./theme/light.css";
import {
  getCapacitorPreference,
  removeCapacitorPreference,
  setCapacitorPreference,
} from "./utils/core-utils/capPreferencesUtils";
import {
  connect,
  send,
  subscribeToService,
  subscribeToServiceQueue,
} from "./utils/sockets/asyncSocket";
import { createPayload } from "./utils/sockets/payload";
import { fetchTermsAndCondition } from "./utils/termsConditionManagement/termsConditionManagement";
import { fetchEntitlements } from "./utils/tokenManagement/tokenManagement";
import config_common from "./platforms/cmed/common/utils/config_common";
// ----- Start :: Custom Stylesheets for Components :: Start -------
import { format } from "date-fns";
import jwtDecode from "jwt-decode";
import {
  AppThemes,
  CapacitorPreferencesConstants,
  EndpointsConstants,
  MetricConstants,
} from "./components/Constants";
import "./theme/custom-components/cmedm__customtable.css";
import "./theme/custom-components/cmedm__ion-chip.css";
import "./theme/custom-components/cmedm__ion-item.css";
import "./theme/custom-components/cmedm__ion-segment.css";
import "./theme/custom-components/cmedm__ion-tab-bar.css";
import "./theme/custom-components/cmedm__ion-toolbar.css";
import "./theme/custom-components/cmedm__list-header.css";
import "./theme/custom-components/cmedm__ion-button.css";
import "./theme/custom-components/cmedm__ion-datetime-button.css";
import "./theme/custom-components/cmedm__ion-badge.css";
import "./theme/custom-components/cmedm__ion-fab-button.css";
import { cancelAllMetrics, endMetric } from "./utils/metric-utils/metricUtils";
import { FE_URL } from "./utils/urlUtils";
import { OrdersDataType, OrdersType } from "./Constants";
import { AlertingStatusProvider } from "./components/contexts/AlertingStatusContext";
import AppPrefContext from "./components/contexts/AppPrefContext";
// ----- End :: Custom Stylesheets for Components :: End -------

const isWebMode = Capacitor.getPlatform().includes("web");

setupIonicReact({
  hardwareBackButton: false,
  rippleEffect: false,
  swipeBackEnabled: false,
});
interface DecodedToken {
  sub?: string;
}

export function fetchUserPreferences() {
  send(config.socket.channels.CORE, {
    action: "getpreference",
    requestID: uuidv4(),
  });
}

export function fetchPersistedOptionGrids() {
  send(config.socket.channels.CORE, {
    action: "getPersistedOptionGrids",
    requestID: uuidv4(),
  });
}

export function fetchUserFullName() {
  send(config.socket.channels.CORE, {
    action: "getFullName",
    requestID: uuidv4(),
  });
}
export async function saveFirebaseDeviceToken() {
  const value = await getCapacitorPreference(
    CapacitorPreferencesConstants.FIREBASE_TOKEN,
  );
  value &&
    send(config.socket.channels.CORE, {
      action: "saveFirebaseToken",
      type: "saveFirebaseToken",
      requestID: uuidv4(),
      payload: {
        token: value,
      },
    });
}

const App: React.FC = () => {
  const isReconnecting = useRef(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isReconnectingState, setisReconnectingState] = useState(false);
  const [isSuccessToastOpen, setIsSuccessToastOpen] = useState(false);
  const [isAlertToastOpen, setIsAlertToastOpen] = useState(false);
  const [isTradingTopToastOpen, setIsTradingTopToastOpen] = useState(false);
  const [isReloginOpen, setIsReloginOpen] = useState(false);
  const [isRetryOpen, setIsRetryOpen] = useState(false);
  const [isLogoutOpen, setIsLogoutOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [alertToastMessage, setAlertToastMessage] = useState("");
  const [topToastData, setTopToastData] = useState<any>([]);
  const [accessToken, setAccessToken] = useState<AccessTokenContextType>();
  const [entitlements, setEntitlements] = useState<EntitlementContextType>();
  const [redirectPath, setRedirectPath] = useState("");
  const [noCMEDAccess, setNoCMEDAccess] = useState(false);
  const [persistedOptionGrids, setPersistedOptionGrids] =
    useState<any>(undefined);
  const [loginResponseStatus, setloginResponseStatus] =
    useState<boolean>(false);
  const [userPreferences, setUserPreferences] = useState<UserPreferences>({
    id: undefined,
    theme: AppThemes.DARK,
    app_tour: "",
    tab_order: "1,2,3,4,5,6",
    flashonchatmessage: false,
    enablepushnotifications: false,
    enablepushnotificationssound: false,
    defaultaccount: "",
    fontSize: "MEDIUM",
    tradinggridgroupsorder: "",
    aggregatedview: false,
    pnlview: false,
  });
  const [isUserTermsConditionAccepted, setIsUserTermsConditionAccepted] =
    useState(undefined);
  const [sendRequest, setSendRequest] = useState<any>();
  const [isCMEDProfileSelectionCompleted, setIsCMEDProfileSelectionCompleted] =
    useState(false);
  const [isUserSettingsModalOpen, setIsUserSettingsModalOpen] = useState(false);
  const [isNetworkAvailableToastOpen, setIsNetworkAvailableToastOpen] =
    useState(false);
  const [networkAvailableToastMessage, setNetworkAvailableToastMessage] =
    useState("");
  const [isSoftUpdateNeeded, setisSoftUpdateNeeded] = useState(false);
  const [isForceUpdateNeeded, setisForceUpdateNeeded] = useState(false);
  const appPref = useContext(AppPrefContext);
  const [hasBeaconAccess, setHasBeaconAccess] = useState(false);

  const navigation = useIonRouter();

  let requestTradingOrders = {
    action: config.socket.actions.CMED_ORDERS_SUBSCRIBE,
    type: OrdersType.ORDERS_DATA_SUBSCRIBE,
    requestID: uuidv4(),
    payload: {
      ordersDataType: OrdersDataType.TRADING_ORDERS,
    },
  };

  let tradingRequest = {
    action: config.socket.actions.CMED_ORDERS_SUBSCRIBE,
    type: OrdersType.TRADING_MARKET_ACTIVITIES,
    requestID: uuidv4(),
    payload: {
      ordersDataType: OrdersDataType.TRADING_MARKET_ACTIVITIES,
    },
  };

  function subscribeToOrderBook() {
    send(config.socket.channels.TRADING, requestTradingOrders);
  }

  async function getAppInfo() {
    const info = await AppCap.getInfo();
    console.log(info);
    if (Capacitor.getPlatform() === "ios") {
      return `${info.version}.${info.build}`;
    } else {
      return info.version;
    }
  }

  async function checkForUpdates() {
    const currentVersion = await getAppInfo();
    let res;
    try {
      res = await fetch(FE_URL + EndpointsConstants.METADATA_ENDPOINT);
    } catch (error) {
      return false;
    }
    const { minSupportedVersion, latestVersion } = await res.json();
    const versionCompare = compareVersions(currentVersion, minSupportedVersion);
    const isBelowMin = versionCompare < 0;
    const isBelowLatest = compareVersions(currentVersion, latestVersion);
    if (isBelowMin) {
      setisForceUpdateNeeded(true);
      send(config.socket.channels.TRADING, {
        action: "logoff",
        requestID: uuidv4(),
        type: "",
        payload: "",
      });
      return true; //return true for force update
    } else if (isBelowLatest === -1) {
      //only if current version is less than latest version
      const shouldShow = await shouldShowSoftUpdate(24);
      if (shouldShow) {
        setisSoftUpdateNeeded(true);
      }
    }
    return false; //return false for soft update/no update
  }

  function compareVersions(v1: string, v2: string) {
    const a = v1.split(".").map(Number);
    const b = v2.split(".").map(Number);
    for (let i = 0; i < Math.max(a.length, b.length); i++) {
      const diff = (a[i] || 0) - (b[i] || 0);
      if (diff !== 0) return diff > 0 ? 1 : -1;
    }
    return 0;
  }

  AppCap.addListener("appStateChange", async ({ isActive }) => {
    if (isActive === false && !isWebMode) {
      setisForceUpdateNeeded(false);
      setisSoftUpdateNeeded(false);
    }
  });

  const shouldShowSoftUpdate = async (
    intervalHours: number = 24,
  ): Promise<boolean> => {
    const value = await getCapacitorPreference(
      CapacitorPreferencesConstants.LAST_SOFT_UPDATE,
    );
    if (!value) return true;

    const lastShown = new Date(value);
    const now = new Date();
    const millisecondsDiff = now.getTime() - lastShown.getTime();
    const hoursDiff = millisecondsDiff / (1000 * 60 * 60); // Convert milliseconds to hours
    return hoursDiff > intervalHours;
  };

  function subscribeToPositions() {
    let RequestTradingPositionAggregates = {
      action: "cmed/orders/subscribe",
      type: "ordersDataSubscribe",
      requestID: uuidv4(),
      payload: {
        ordersDataType: "TradingPositionAggregates",
      },
    };
    send(config.socket.channels.TRADING, RequestTradingPositionAggregates);
  }

  const addPushListeners = async () => {
    // On success, we should be able to receive notifications
    PushNotifications.addListener("registration", async (token: Token) => {
      const oldToken = await getCapacitorPreference(
        CapacitorPreferencesConstants.FIREBASE_TOKEN,
      );
      if (token.value !== oldToken) {
        console.log("Push registration success, new token: " + token.value);
        await setCapacitorPreference(
          CapacitorPreferencesConstants.FIREBASE_TOKEN,
          token.value,
        );
        await setCapacitorPreference(
          CapacitorPreferencesConstants.FCM_TOKEN_NEEDS_SYNC,
          "true",
        );
      }
    });
    // Some issue with our setup and push will not work
    PushNotifications.addListener("registrationError", (error: any) => {
      console.log("Error on registration: " + JSON.stringify(error));
    });

    // Show us the notification payload if the app is open on our device
    PushNotifications.addListener(
      "pushNotificationReceived",
      (notification: PushNotificationSchema) => {
        console.log("Push received: " + JSON.stringify(notification));
      },
    );

    // Method called when tapping on a notification
    PushNotifications.addListener(
      "pushNotificationActionPerformed",
      (notification: ActionPerformed) => {
        console.log("Push action performed: " + JSON.stringify(notification));
      },
    );
  };

  const requestPushPermission = async () => {
    // Request permission to use push notifications
    // iOS will prompt user and return if they granted permission or not
    // Android will just grant without prompting
    PushNotifications.requestPermissions().then((result) => {
      if (result.receive === "granted") {
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register();
      } else {
        // Show some error
        console.log("No permission for push notifications");
      }
    });
  };

  const setupPushNotifications = async () => {
    !isWebMode && (await addPushListeners());
    !isWebMode && (await requestPushPermission());
  };

  useEffect(() => {
    setCapacitorPreference(
      CapacitorPreferencesConstants.IS_LOGIN_COMPLETE,
      "false",
    );
    setupPushNotifications();
    PubSub.subscribe(pubsubEvents.socketKeys.CONNECTED_WEBSOCKET, async () => {
      setloginResponseStatus(false);
      console.log("TRIGGER STARTUP DONE");
      subscribeToServiceQueue("responses");
      subscribeToService("cmed");
      subscribeToService("trading");
      subscribeToServiceQueue("alerts");
      subscribeToServiceQueue("trading");
      console.log("STARTUP RECONNECTING ", isReconnecting);
      isReconnecting.current &&
        send(
          config.socket.channels.TRADING,
          createPayload(config.socket.actions.CMED_LOGON, "loginRequest", {}),
        );
      subscribeToService("trading-service");

      localStorage.setItem("loggedOut", "false");
      if (!isWebMode) {
        const needsSync = await getCapacitorPreference(
          CapacitorPreferencesConstants.FCM_TOKEN_NEEDS_SYNC,
        );
        if (needsSync === "true") {
          await saveFirebaseDeviceToken();
          // Once synced, clear the flag.
          await removeCapacitorPreference(
            CapacitorPreferencesConstants.FCM_TOKEN_NEEDS_SYNC,
          );
        }
      }
      const value = await getCapacitorPreference(
        CapacitorPreferencesConstants.ACCESS_TOKEN,
      );
      const accTok = {
        accessToken: value?.replaceAll('"', ""),
        valid: true,
      };

      setAccessToken(accTok);
      const entitlements = await fetchEntitlements(value);
      fetchUserPreferences();
      fetchUserFullName();
      fetchPersistedOptionGrids();
      isReconnecting.current = false;
      appPref != null && appPref.setIsAppActive(true);
      var ents = {
        entitlements: entitlements
          .replaceAll('"', "")
          .replaceAll(" ", "")
          .split(","),
      };
      if (entitlements.split(",").includes("CMED")) {
        setRedirectPath(CMEDRoutes.MARKET_DATA);
        const decoded = jwtDecode<DecodedToken>(value || "");
        if (decoded?.sub) {
          FirebaseAnalytics.setUserId({
            userId: decoded?.sub,
          });
          FirebaseAnalytics.setUserProperty({
            name: "cmed_mobile_user_id",
            value: decoded?.sub,
          });
          FirebaseAnalytics.setUserProperty({
            name: "last_login_date_time",
            value: format(new Date(), "dd/MM/yyyy HH:mm:ss"),
          });
        }
      } else {
        console.log("NO ACCESS");
        setRedirectPath(`/noaccess`);
        PubSub.publish(
          pubsubEvents.errorKeys.TRADING_SERVICE_ERROR_POPUP_RELOGIN,
          {
            errors:
              "You do not have access to CME Direct Mobile. Please contact GCC",
          },
        );
      }
      setEntitlements(ents);
    });

    PubSub.subscribe(
      pubsubEvents.socketKeys.ATTEMPT_VISIBILITY_RECONNECT,
      (msg, data) => {
        onLogin();
      },
    );

    const checkIfOrderBookViewModalOpenAndSubscribe = async () => {
      try {
        const orderId = await getCapacitorPreference(
          CapacitorPreferencesConstants.ORDERBOOK_MODAL_ORDERID,
        );
        if (orderId) {
          let subRequestForTradingOrderDetails = {
            action: optionGridConfig.socket.actions.CMED_ORDERS_SUBSCRIBE,
            type: OrdersType.ORDERS_DATA_SUBSCRIBE,
            requestID: uuidv4(),
            payload: {
              orderId: orderId,
              ordersDataType: OrdersDataType.TRADING_ORDER_DETAILS,
            },
          };
          send(
            config.socket.channels.TRADING,
            subRequestForTradingOrderDetails,
          );
        } else {
          console.log("OrderBookViewModalOpen_orderId not found.");
        }
      } catch (error) {
        console.error("Error getting OrderBookViewModalOpen_orderId:", error);
      }
    };

    const checkIfMarketDataOverviewModalOpenAndSubscribe = async () => {
      try {
        const insId = await getCapacitorPreference(
          CapacitorPreferencesConstants.MARKETDATA_MODAL_INSTRUMENT_ID,
        );
        if (insId) {
          let subRequestForContractMarketData = {
            action: config.socket.actions.CMED_ORDERS_SUBSCRIBE,
            type: OrdersType.CONTRACT_MARKET_DATA,
            requestID: uuidv4(),
            payload: {
              ordersDataType: OrdersDataType.CONTRACT_MARKET_DATA,
              itemId: insId,
            },
          };
          send(config.socket.channels.TRADING, subRequestForContractMarketData);
        } else {
          console.log("MarketDataOverviewModalOpen_insId not found.");
        }
      } catch (error) {
        console.error(
          "Error getting MarketDataOverviewModalOpen_insId:",
          error,
        );
      }
    };

    const setFontSize = (size: string) => {
      document.body.classList.remove("font-small", "font-medium", "font-large");
      document.body.classList.add(size);
    };

    PubSub.subscribe(
      pubsubEvents.stompSubscriptionKeys.CMED_USER_LOGON_SUCCESS,
      (msg, data) => {
        endMetric(MetricConstants.TIME_TO_FIRST_PAINT_LOGIN);
        if (data.payload.isLoggedIn) {
          setloginResponseStatus(true);
          /**
           * @description
           * Check beacon access
           */
          send(config.socket.channels.CORE, {
            action: "checkBeaconAccess",
            type: "legacyValidation",
            requestID: uuidv4(),
            payload: {
              username: data?.payload?.loginSelection?.displayText,
            },
          });
          /**
           * @description
           * marketdata, orderbook, blockfeed, options grid all the modals resubscriptions
           */
          isReconnecting.current && subscribeToMarketData(); // no need to remove isReconnecting logic as market data grid is the initially loaded component
          subscribeToOrderBook();
          isReconnecting.current && subscribeToPositions(); // reconnecting logic here, since subscription is sent while loading the component and not here
          /**
           * @TODO -> Find a way to handle when the the ids are not valid if the app is closed by the user
           */
          isReconnecting.current && checkIfOrderBookViewModalOpenAndSubscribe();
          isReconnecting.current &&
            checkIfMarketDataOverviewModalOpenAndSubscribe();
          setCapacitorPreference(
            CapacitorPreferencesConstants.IS_LOGIN_COMPLETE,
            data.payload.isLoggedIn.toString(),
          );
        }
      },
    );

    PubSub.subscribe(
      pubsubEvents.socketKeys.CMED_OPTIONSGRID_FETCH,
      (msg, data) => {
        setPersistedOptionGrids(JSON.parse(data.payload));
      },
    );

    PubSub.subscribe(
      pubsubEvents.socketKeys.CMED_OPTIONSGRID_SAVE_SUCCESS,
      (msg, data) => {
        fetchPersistedOptionGrids();
      },
    );

    PubSub.subscribe(
      pubsubEvents.stompSubscriptionKeys.CMED_USER_LOGON_RESPONSE_SUCCESS,
      loginResponseStatusFx,
    );

    PubSub.subscribe(
      pubsubEvents.stompSubscriptionKeys.CMED_LOGIN_SELECTION_NEEDED,
      loginSelectionNeeded,
    );

    PubSub.subscribe(
      pubsubEvents.errorKeys.TRADING_SERVICE_ERROR_MODAL_LOGOUT,
      (msg, data) => {
        setNoCMEDAccess(true);
        console.log("Trading Service - Logout: ", data?.errors[0]);
      },
    );

    PubSub.subscribe(pubsubEvents.socketKeys.ATTEMPT_RECONNECT, () => {
      // setIsReloginOpen(true);
      // console.log("Trading Service - Re-Login: Server disconnected");
      // setToastMessage("There was some error connecting to server!");
      // setIsReconnecting(true)
      isReconnecting.current = true;
      setisReconnectingState(true);
      appPref?.setIsAppActive(false);
      // unsubscribeAll()
    });

    PubSub.subscribe(
      pubsubEvents.socketKeys.PREFERENCES_SUCCESS,
      (msg, data) => {
        const payloadData = JSON.parse(data.payload);
        if (
          payloadData.hasOwnProperty("defaultaccount") &&
          payloadData.hasOwnProperty("fontSize")
        ) {
          setUserPreferences({ ...payloadData, theme: AppThemes.DARK });
        } else if (
          !payloadData.hasOwnProperty("defaultaccount") &&
          payloadData.hasOwnProperty("fontSize")
        ) {
          setUserPreferences({
            ...payloadData,
            theme: "dark",
            defaultaccount: "",
          });
        } else if (
          payloadData.hasOwnProperty("defaultaccount") &&
          !payloadData.hasOwnProperty("fontSize")
        ) {
          setUserPreferences({
            ...payloadData,
            theme: "dark",
            fontSize: "MEDIUM",
          });
        } else {
          setUserPreferences({
            ...payloadData,
            theme: AppThemes.DARK,
            defaultaccount: "",
            fontSize: "MEDIUM",
          });
        }
        if (payloadData.hasOwnProperty("fontSize")) {
          switch (payloadData.fontSize) {
            case "SMALL":
              setFontSize(config_common.fontSizes.SMALL);
              break;
            case "MEDIUM":
              setFontSize(config_common.fontSizes.MEDIUM);
              break;
            case "LARGE":
              setFontSize(config_common.fontSizes.LARGE);
              break;
            default:
              setFontSize(config_common.fontSizes.MEDIUM);
          }
        } else {
          setFontSize(config_common.fontSizes.MEDIUM);
        }
      },
    );

    function subscribeToMarketData() {
      let request1 = {
        action: optionGridConfig.socket.actions.CMED_ORDERS_SUBSCRIBE,
        type: OrdersType.ORDERS_DATA_SUBSCRIBE,
        requestID: uuidv4(),
        payload: {
          ordersDataType: "TradingGridGroupsV2",
        },
      };
      let request2 = {
        action: optionGridConfig.socket.actions.CMED_ORDERS_SUBSCRIBE,
        type: OrdersType.ORDERS_DATA_SUBSCRIBE,
        requestID: uuidv4(),
        payload: {
          orderId: "",
          ordersDataType: OrdersDataType.TRADING_USER_DETAILS,
        },
      };
      send(config.socket.channels.TRADING, request1);
      send(config.socket.channels.TRADING, request2);
    }

    if (localStorage.getItem("loggedOut") !== "true") {
      console.warn(
        "\r\n _    _      _                            _        \r\n| |  | |    | |                          | |       \r\n| |  | | ___| | ___ ___  _ __ ___   ___  | |_ ___  \r\n| |/\\| |/ _ \\ |/ __/ _ \\| '_ ` _ \\ / _ \\ | __/ _ \\ \r\n\\  /\\  /  __/ | (_| (_) | | | | | |  __/ | || (_) |\r\n \\/  \\/ \\___|_|\\___\\___/|_| |_| |_|\\___|  \\__\\___/ \r\n                                                   \r\n                                                   \r\n" +
          "\r\n _____ ___  ___ ___________  ___  ______________ _____ _      _____   _____  _____ \r\n/  __ \\|  \\/  ||  ___|  _  \\ |  \\/  |  _  | ___ \\_   _| |    |  ___| / __  \\|  _  |\r\n| /  \\/| .  . || |__ | | | | | .  . | | | | |_/ / | | | |    | |__   `' / /'| |/' |\r\n| |    | |\\/| ||  __|| | | | | |\\/| | | | | ___ \\ | | | |    |  __|    / /  |  /| |\r\n| \\__/\\| |  | || |___| |/ /  | |  | \\ \\_/ / |_/ /_| |_| |____| |___  ./ /___\\ |_/ /\r\n \\____/\\_|  |_/\\____/|___/   \\_|  |_/\\___/\\____/ \\___/\\_____/\\____/  \\_____(_)___/ \r\n                                                                                   \r\n                                                                                   \r\n" +
          "\r\n\u250F\u2513            \u2513  \u2513     \u250F\u2513\u2533\u2533\u2513\u250F\u2513  \u250F\u2513        \r\n\u2503\u2503\u250F\u2513\u2513\u250F\u250F\u250F\u2513\u250F\u2513\u250F\u2513\u250F\u252B  \u2523\u2513\u2513\u250F  \u2503 \u2503\u2503\u2503\u2523   \u2503\u2513\u250F\u2513\u250F\u2513\u2513\u250F\u250F\u2513\r\n\u2523\u251B\u2517\u251B\u2517\u253B\u251B\u2517 \u251B \u2517 \u2517\u253B  \u2517\u251B\u2517\u252B  \u2517\u251B\u251B \u2517\u2517\u251B  \u2517\u251B\u251B \u2517\u251B\u2517\u253B\u2523\u251B\r\n                    \u251B                   \u251B \r\n",
      );

      if (!window.location.search.toString().includes("code")) {
        onLogin();
      }
    }
    localStorage.setItem("loggedOut", "false");

    PubSub.subscribe(pubsubEvents.errorKeys.CORE_ERROR_TOAST, (msg, data) => {
      console.log("Core", data.errors[0]);
      setIsOpen(true);
      setToastMessage(data.errors);
    });

    PubSub.subscribe(
      pubsubEvents.errorKeys.TRADING_SERVICE_ERROR_POPUP_RELOGIN,
      (msg, data) => {
        isReconnecting.current === false &&
          isLogoutOpen == false &&
          setIsReloginOpen(true);
        setCapacitorPreference(
          CapacitorPreferencesConstants.IS_LOGIN_COMPLETE,
          "false",
        );
        console.log("Trading Service - Re-Login: ", data?.errors[0]);
        setToastMessage(data?.errors);
      },
    );

    PubSub.subscribe(
      pubsubEvents.errorKeys.TRADING_SERVICE_ERROR_POPUP_LOGOUT,
      (msg, data) => {
        isReloginOpen == false && setIsLogoutOpen(true);
        console.log("Trading Service - Logout: ", data?.errors[0]);
        setToastMessage(data?.errors);
      },
    );

    PubSub.subscribe(
      pubsubEvents.errorKeys.MARKET_SERVICE_ERROR_TOAST,
      (msg, data) => {
        console.log("Market Service", data?.errors[0]);
        setIsOpen(true);
        let errorResponse;
        if (!data.errors.isArray) errorResponse = data?.errors;
        else
          errorResponse = data?.errors?.map((item: any, index: any) =>
            index == 1 || index == 0 ? item + " " : item,
          );
        setToastMessage(errorResponse);
      },
    );

    PubSub.subscribe(
      pubsubEvents.errorKeys.MARKET_SERVICE_ERROR_TOAST_RETRY,
      (msg, data) => {
        console.log("Market Service", data?.errors[0]);
        setIsRetryOpen(true);
        setToastMessage(data.errors);
      },
    );

    PubSub.subscribe(pubsubEvents.errorKeys.CMED_ERROR_TOAST, (msg, data) => {
      console.log("Generic", data.errors[0]);
      if (data.errors[0] === "CmedToken is unknown") {
        console.log("CmedToken is unknown ", data.errors[0]);
        isLogoutOpen == false && setIsReloginOpen(true);
        setCapacitorPreference(
          CapacitorPreferencesConstants.IS_LOGIN_COMPLETE,
          "false",
        );
      } else {
        setIsOpen(true);
      }
      setToastMessage(data.errors);
    });

    PubSub.subscribe(pubsubEvents.successKeys.NETWORK_UP_TOAST, (msg, data) => {
      setIsNetworkAvailableToastOpen(true);
      setNetworkAvailableToastMessage(data);
    });

    PubSub.subscribe(
      pubsubEvents.successKeys.TRADING_SERVICE_SUCCESS_TOAST,
      (msg, data) => {
        setIsSuccessToastOpen(true);
        setToastMessage(data);
      },
    );

    PubSub.subscribe(
      pubsubEvents.successKeys.TRADING_SERVICE_TOAST_TOP,
      (msg, data) => {
        setIsTradingTopToastOpen(true);
        setTopToastData(data);
      },
    );

    PubSub.subscribe(
      pubsubEvents.successKeys.ALERT_NOTIFICATION_TOAST,
      (msg, data) => {
        setIsAlertToastOpen(true);
        setAlertToastMessage(data);
      },
    );

    PubSub.subscribe(
      pubsubEvents.socketKeys.CHECK_BEACON_ACCESS_SUCCESS,
      (msg, data) => {
        setHasBeaconAccess(data?.payload);
        setCapacitorPreference(
          CapacitorPreferencesConstants.BEACON_ACCESS,
          String(data?.payload),
        );
      },
    );

    const checkBeaconAccess = async () => {
      const access = await getCapacitorPreference(
        CapacitorPreferencesConstants.BEACON_ACCESS,
      );
      setHasBeaconAccess(access === "true");
    };
    checkBeaconAccess();

    return () => {
      cancelAllMetrics();
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      persistedOptionGrids !== undefined && setisReconnectingState(false);
      endMetric(MetricConstants.TIME_TO_FIRST_PAINT_RECONNECTING_STATE_CHANGE);
      endMetric(MetricConstants.TIME_TO_FIRST_PAINT_RECONNECTING_NETWORK);
    }, 100);

    return () => clearTimeout(timer);
  }, [persistedOptionGrids]);

  var loginResponseStatusFx = function (msg: any, data: any) {
    setloginResponseStatus(data.payload === "true");
    setIsReloginOpen(false);
    setIsLogoutOpen(false);
  };

  var loginSelectionNeeded = function (msg: any, data: any) {
    setloginResponseStatus(!loginResponseStatus);
    setIsReloginOpen(false);
    setIsLogoutOpen(false);
  };

  useEffect(() => {
    const initFirebaseAnalytics = async () => {
      if (Capacitor.getPlatform() === "web") {
        FirebaseAnalytics.initializeFirebase({
          apiKey: process.env.REACT_APP_FIREBASE_APIKEY || "",
          authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN || "",
          projectId: process.env.REACT_APP_FIREBASE_PROJECTID || "",
          storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET || "",
          messagingSenderId:
            process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID || "",
          appId: process.env.REACT_APP_FIREBASE_APPID || "",
          measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID || "",
        });
      }
    };

    initFirebaseAnalytics();
  }, []);

  async function onLogin() {
    var ents;
    var forceUpdate;
    if (Capacitor.getPlatform() !== "web") {
      forceUpdate = await checkForUpdates();
    } else {
      forceUpdate = false; // not needed for web version
    }
    const value = await getCapacitorPreference(
      CapacitorPreferencesConstants.ACCESS_TOKEN,
    );
    console.log("accessToken", value);
    if (
      value !== undefined &&
      value !== "" &&
      value !== null &&
      forceUpdate === false
    ) {
      const response = await fetchTermsAndCondition(value);
      if (response) {
        await connect(value);
      } else {
        setRedirectPath(CMEDRoutes.MARKET_DATA);
      }
      const accTok = {
        accessToken: value?.replaceAll('"', ""),
        valid: true,
      };
      setAccessToken(accTok);
      fetchUserFullName();
      setIsUserTermsConditionAccepted(response);
      const path = localStorage.getItem("last-visited-link");
      if (path !== undefined && path !== null) {
        navigation.push(path.toString());
        setEntitlements(ents);
      }
    } else {
      console.error("❌ ACCESS TOKEN IS UNKNOWN");
      let isMobile: boolean = Capacitor.isNativePlatform();
      if (forceUpdate === false) {
        !isMobile ? DesktopBrowser() : MobileBrowser();
      }
    }
  }

  function accessTokenfetched() {
    console.log("accessTokenfetched");
    onLogin();
  }

  return (
    <>
      <IonApp>
        <IonReactRouter>
          <UserPrefencesContext.Provider
            value={{ userPreferences, setUserPreferences }}
          >
            <AlertingStatusProvider>
              <BeaconAccessContext.Provider
                value={{ hasBeaconAccess, setHasBeaconAccess }}
              >
                <App1
                  setIsReconnectingState={setisReconnectingState}
                  onLogin={onLogin}
                  persistedOptionGrids={persistedOptionGrids}
                />
                <DesktopHeader
                  entitlements={entitlements?.entitlements}
                  isUserTermsConditionAccepted={isUserTermsConditionAccepted}
                  isCMEDProfileSelectionCompleted={
                    isCMEDProfileSelectionCompleted
                  }
                  isUserSettingsModalOpen={isUserSettingsModalOpen}
                  setIsUserSettingsModalOpen={setIsUserSettingsModalOpen}
                />
                {accessToken?.valid && <Redirect from="*" to={redirectPath} />}
                <PlatformsSwitcher
                  onLogin={accessTokenfetched}
                  entitlements={entitlements}
                  accessToken={accessToken}
                  accessTokenfetched={accessTokenfetched}
                  isUserTermsConditionAccepted={isUserTermsConditionAccepted}
                  setIsUserTermsConditionAccepted={
                    setIsUserTermsConditionAccepted
                  }
                  loginResponseStatus={loginResponseStatus}
                  setSendRequest={setSendRequest}
                  sendRequest={sendRequest}
                  noCMEDAccess={noCMEDAccess}
                  setIsCMEDProfileSelectionCompleted={
                    setIsCMEDProfileSelectionCompleted
                  }
                  isUserSettingsModalOpen={isUserSettingsModalOpen}
                  persistedOptionGrids={persistedOptionGrids}
                  setPersistedOptionGrids={setPersistedOptionGrids}
                />
              </BeaconAccessContext.Provider>
            </AlertingStatusProvider>
          </UserPrefencesContext.Provider>{" "}
        </IonReactRouter>
        <IonToast
          color="success"
          isOpen={isSuccessToastOpen}
          icon={checkmarkCircleOutline}
          message={toastMessage}
          onDidDismiss={() => setIsSuccessToastOpen(false)}
          duration={
            toastMessage[0] && toastMessage[0].length <= 20 ? 5000 : 10000
          }
          buttons={[
            {
              text: "Dismiss",
              role: "cancel",
            },
          ]}
        ></IonToast>
        {hasBeaconAccess && (
          <IonToast
            color="primary"
            isOpen={isAlertToastOpen}
            // position="top"
            icon={informationCircle}
            message={alertToastMessage}
            onDidDismiss={() => {
              setIsAlertToastOpen(false);
              setAlertToastMessage("");
            }}
            duration={10000}
            buttons={[
              {
                text: "Dismiss",
                role: "cancel",
              },
            ]}
          ></IonToast>
        )}
        <IonToast
          color="success"
          isOpen={isNetworkAvailableToastOpen}
          icon={wifi}
          message={networkAvailableToastMessage}
          duration={2000}
          onDidDismiss={() => setIsNetworkAvailableToastOpen(false)}
        ></IonToast>
        <IonToast
          color={topToastData[1]}
          isOpen={isTradingTopToastOpen}
          icon={
            topToastData[1] === "success"
              ? checkmarkCircleOutline
              : topToastData[1] === "danger"
                ? alertCircleOutline
                : informationCircle
          }
          message={topToastData[0]}
          onDidDismiss={() => setIsTradingTopToastOpen(false)}
          duration={
            topToastData[0] && topToastData[0].length <= 20 ? 5000 : 10000
          }
          buttons={[
            {
              text: "Dismiss",
              role: "cancel",
            },
          ]}
        ></IonToast>
        <IonToast
          color="danger"
          isOpen={isOpen}
          icon={alertCircleOutline}
          message={toastMessage}
          onDidDismiss={() => setIsOpen(false)}
          duration={
            toastMessage[0] && toastMessage[0].length <= 20 ? 5000 : 10000
          }
          buttons={[
            {
              text: "Dismiss",
              role: "cancel",
            },
          ]}
        ></IonToast>
        <IonToast
          color="danger"
          isOpen={isRetryOpen}
          icon={alertCircleOutline}
          message={isArray(toastMessage) ? toastMessage[0] : toastMessage}
          duration={
            (toastMessage[0] && toastMessage[0].length <= 20) ||
            (toastMessage[0] &&
              toastMessage[0].length <= 1 &&
              toastMessage.length <= 20)
              ? 5000
              : 10000
          }
          // swipeGesture="vertical"
          onDidDismiss={() => setIsRetryOpen(false)}
          buttons={[
            {
              text: "Retry",
              role: "Retry",
              handler: () => {
                send(config.socket.channels.TRADING, sendRequest);
                setIsRetryOpen(false);
              },
            },
            {
              text: "Dismiss",
              role: "cancel",
            },
          ]}
        ></IonToast>
        <IonAlert
          isOpen={isLogoutOpen}
          header="ACCESS REQUIRED"
          subHeader={isArray(toastMessage) ? toastMessage[0] : toastMessage}
          backdropDismiss={false}
          buttons={[
            {
              text: "Logout",
              role: "Logout",
              handler: () => {
                console.log("Logout clicked");
                localStorage.setItem("loggedOut", "true");
                removeCapacitorPreference("accessToken");
                setCapacitorPreference(
                  CapacitorPreferencesConstants.BEACON_ACCESS,
                  "false",
                );
                setCapacitorPreference(
                  CapacitorPreferencesConstants.IS_LOGIN_COMPLETE,
                  "false",
                );
                window.location.assign("/logout_success");
                setIsLogoutOpen(false);
                send("/app/trading", {
                  action: "logoff",
                  requestID: uuidv4(),
                  type: "",
                  payload: "",
                });
              },
            },
          ]}
        ></IonAlert>
        <IonAlert
          isOpen={isReloginOpen}
          header="Connection Error"
          subHeader={isArray(toastMessage) ? toastMessage[0] : toastMessage}
          backdropDismiss={false}
          buttons={[
            {
              text: "Re-Login",
              role: "Re-Login",
              handler: () => {
                console.log("Re-Login clicked");
                removeCapacitorPreference("accessToken");
                setCapacitorPreference(
                  CapacitorPreferencesConstants.IS_LOGIN_COMPLETE,
                  "false",
                );
                localStorage.setItem("loggedOut", "false");
                isWebMode && window.location.replace(FE_URL + "");
                !isWebMode && onLogin();
                setIsReloginOpen(false);
              },
            },
          ]}
        ></IonAlert>
        {isForceUpdateNeeded && (
          <IonAlert
            isOpen={isForceUpdateNeeded}
            header="New Version Required"
            subHeader={
              "Please update the application to continue using CME Direct."
            }
            backdropDismiss={false}
            buttons={[
              {
                text: "Update",
                role: "Update",
                handler: () => {
                  setisForceUpdateNeeded(false);
                  Capacitor.getPlatform() === "ios"
                    ? window.location.replace(
                        "https://apps.apple.com/app/cmed-mobile/id6654917516",
                      )
                    : window.location.replace(
                        "https://play.google.com/store/apps/details?id=com.cme.one.cmedmobile",
                      );
                },
              },
            ]}
          ></IonAlert>
        )}
        {isSoftUpdateNeeded && (
          <IonAlert
            isOpen={isSoftUpdateNeeded}
            header="New Version Available"
            subHeader={
              "A new version of CME Direct is available with new features and improvements! We recommend updating for the best experience."
            }
            backdropDismiss={false}
            buttons={[
              {
                text: "Update",
                role: "Update",
                handler: () => {
                  setisSoftUpdateNeeded(false);
                  removeCapacitorPreference(
                    CapacitorPreferencesConstants.LAST_SOFT_UPDATE,
                  );
                  Capacitor.getPlatform() === "ios"
                    ? window.location.replace(
                        "https://apps.apple.com/app/cmed-mobile/id6654917516",
                      )
                    : window.location.replace(
                        "https://play.google.com/store/apps/details?id=com.cme.one.cmedmobile",
                      );
                },
              },
              {
                text: "Later",
                role: "Later",
                handler: () => {
                  setisSoftUpdateNeeded(false);
                  setCapacitorPreference(
                    CapacitorPreferencesConstants.LAST_SOFT_UPDATE,
                    new Date().toISOString(),
                  );
                },
              },
            ]}
          ></IonAlert>
        )}
        <IonLoading
          isOpen={isReconnectingState}
          message="Reconnecting to CMED..."
          spinner="circles"
        />
      </IonApp>
    </>
  );
};

export default withRouter(App);
